import { Address } from '~/LFA/graphql/types';
import { generateConcatenatedNonNullString } from '~/util/textConversion';

/**
 * @description Formats an address object to a string in the format: Dorus Rijkershof 2 H, 1064GG Amsterdam
 * @param address - The address object to format
 * @returns The formatted address string
 */
const formatAddressAsString = (address: Address | undefined | null) => {
  if (!address) return 'Geen adres gevonden';

  return generateConcatenatedNonNullString(
    [
      address.street +
        ' ' +
        String(address.houseNumber) +
        (address.addition ? ` ${address.addition}` : ''),
      address.postcode + ' ' + address.city,
    ],
    ', ',
  );
};

export default formatAddressAsString;
